import { MemberService } from '../member/member.service';
import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EndpointFactory } from '../endpoint-factory.service';
import { ForceBaseUrl, ConfigurationService } from '../configuration/configuration.service';
import { CaseViewModel, IAdvanceStageResult, IHistoricItem, RollbackCaseStageRequestData, AssignCaseOwnershipRequest, ICurrentCaseByCategory, IProductCategoryContext } from 'src/app/models/case';

@Injectable({
    providedIn: 'root'
})
export class ProductContextEndpoint extends EndpointFactory {


    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
        super(http, configurations, injector);
    }

    getServiceBaseUrl(force?: ForceBaseUrl) {
        return this.getBaseUrl('product', force) + 'product';
    }

    getProductContext(tenantId: string, request: ICurrentCaseByCategory): Observable<IProductCategoryContext> {
        const url = `${this.getServiceBaseUrl('WEBAPI')}/${tenantId}/context`;

        return this.http.post<IProductCategoryContext>(url, request).pipe(
            catchError(error => {
                return this.handleError(error);
            }));
    }

}
